import { ArrowOffsetControl } from './controls/arrow';
import { HexagonOffsetControl } from './controls/hexagon';
import { ParallelogramOffsetControl } from './controls/parallelogram';
import { StepOffsetControl } from './controls/step';
import { TrapezoidOffsetControl } from './controls/trapezoid';
import { SquareRadiusControl } from './controls/square';

export const tools: any = {
    arrow: {
        tools: [ArrowOffsetControl],
        control: { arrowHeight: 20, thickness: 10, type: 'arrow' },
    },
    parallelogram: {
        tools: [ParallelogramOffsetControl],
        control: { offset: 10, type: 'parallelogram' },
    },
    hexagon: {
        tools: [HexagonOffsetControl],
        control: { offset: 10, type: 'hexagon' },
    },
    trapezoid: {
        tools: [TrapezoidOffsetControl],
        control: { offset: 10, type: 'trapezoid' },
    },
    step: {
        tools: [StepOffsetControl],
        control: { offset: 10, type: 'step' },
    },
    square: {
        tools: [SquareRadiusControl],
        control: { type: 'square' },
    },
}

export function getTools(type: string) {
    const handleAttrs = { handleAttributes: { fill: 'orange' }}
    return tools[type]?.tools?.map((Tool: any) => {
        return new Tool(handleAttrs);
    })
}
